import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "backgroundsSpritesheets/mobile/22_lonely_mountain/22_lonely_mountain"
 * Contains 1 texture(s)
 */
export class Mobile22LonelyMountainAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'backgroundsSpritesheets/mobile/22_lonely_mountain/22_lonely_mountain';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '22_lonely_mountain.jpg'
    ] as const;
}
